<template>
	<div class="search-tags" v-if="currentTags.length">
		<div class="tags-container">
			<a
				v-for="tag in currentTags"
				:key="tag"
				:href="getSearchUrl(tag)"
				class="tag"
				v-metric="{ module: 'pstags' }"
			>
				<span>{{ tag }}</span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="15"
					viewBox="0 0 16 15"
					fill="none"
				>
					<path
						d="M14.3333 15L9.08333 9.75C8.66667 10.0833 8.1875 10.3472 7.64583 10.5417C7.10417 10.7361 6.52778 10.8333 5.91667 10.8333C4.40278 10.8333 3.12153 10.309 2.07292 9.26042C1.02431 8.21181 0.5 6.93056 0.5 5.41667C0.5 3.90278 1.02431 2.62153 2.07292 1.57292C3.12153 0.524306 4.40278 0 5.91667 0C7.43056 0 8.71181 0.524306 9.76042 1.57292C10.809 2.62153 11.3333 3.90278 11.3333 5.41667C11.3333 6.02778 11.2361 6.60417 11.0417 7.14583C10.8472 7.6875 10.5833 8.16667 10.25 8.58333L15.5 13.8333L14.3333 15ZM5.91667 9.16667C6.95833 9.16667 7.84375 8.80208 8.57292 8.07292C9.30208 7.34375 9.66667 6.45833 9.66667 5.41667C9.66667 4.375 9.30208 3.48958 8.57292 2.76042C7.84375 2.03125 6.95833 1.66667 5.91667 1.66667C4.875 1.66667 3.98958 2.03125 3.26042 2.76042C2.53125 3.48958 2.16667 4.375 2.16667 5.41667C2.16667 6.45833 2.53125 7.34375 3.26042 8.07292C3.98958 8.80208 4.875 9.16667 5.91667 9.16667Z"
						fill="#3557FF"
					/>
				</svg>
			</a>
		</div>
	</div>
</template>

<script>
	import url from 'url';
	import useStore from 'webmd-cms-store/src/store';

	export default {
		name: 'SearchTags',

		data() {
			return {
				tagMap: {
					1020: [
						'Her2',
						'Metastatic Breast Cancer',
						'Breast cancer stages',
						'Kisqali',
						'Types of Breast Cancer',
					],
					1060: [
						'PrEP & HIV',
						'HIV treatment options',
						'HIV transmission methods',
						'HIV testing and diagnosis',
						'Living with HIV',
					],
					1123: [
						'J pouch',
						'Ulcerative Colitis treatment options',
						'Ulcerative Colitis diet',
						'Ulcerative Colitis causes',
						'Ulcerative Colitis flare-up management',
					],
					1136: [
						'Eczema home remedies',
						'Eczema treatment options',
						'Eczema causes',
						'Eczema skincare routine',
						'Eczema images',
					],
				},
				currentTags: [],
			};
		},

		methods: {
			getChannelId() {
				return this.store?.pagedata?.omniture?.center_id || '';
			},

			getTags() {
				const channelId = this.getChannelId();
				return this.tagMap[channelId] || [];
			},

			baseSearchUrl() {
				let canonical = this.store?.pagedata?.meta?.canonicalurl || 'https://www.webmd.com';
				canonical = url.parse(canonical);
				return `https://${canonical.hostname}/search/search_results/default.aspx`;
			},

			getSearchUrl(tag) {
				return `${this.baseSearchUrl()}?query=${encodeURIComponent(tag)}`;
			},
		},

		created() {
			this.store = useStore(this.$pinia);
		},

		mounted() {
			// Initialize tags
			this.currentTags = this.getTags();
		},
	};
</script>

<style lang="scss" scoped>
	$tablet: px2rem(768);
	$breakpoint-mobile: px2rem(466);
	$base-font-family-sans: 'Source Sans Pro', Arial, sans-serif;

	.search-tags {
		margin-top: 1rem;
		width: 100%;
	}

	.tags-container {
		display: flex;
		font-family: $base-font-family-sans;
		gap: 6px;
		overflow-x: auto;
		padding: 0.5rem 0;
		scrollbar-width: none; // Firefox
		-ms-overflow-style: none; // IE/Edge

		&::-webkit-scrollbar {
			display: none; // Chrome/Safari
		}
	}

	.tag {
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 8px;
		background: #f8f8f8;
		border-radius: 4px;
		color: #3557ff;
		font-size: 16px;
		font-weight: 400;
		line-height: 100%;
		letter-spacing: 0%;
		text-decoration: none;
		white-space: nowrap;
		transition: background-color 0.2s;

		&:hover {
			background: darken(#f8f8f8, 5%);
			text-decoration: none;
		}

		svg {
			flex-shrink: 0;
		}
	}

	// Tablet styles
	@media (min-width: 768px) and (max-width: 1024px) {
		.search-tags {
			max-width: var(--feature-module-width, 100%);
			margin: 1rem auto;
		}
	}

	// Desktop styles
	@media (min-width: 1025px) {
		.tags-container {
			flex-wrap: wrap;
			overflow: visible;
		}
	}
</style>
